export default class Navlink {
  constructor(id: number, link: string, scrollToDiv: string, classActive: string) {
    this.id = id;
    this.link = link;
    this.scrollToDiv = scrollToDiv;
    this.classActive = classActive;
  }

  public id: number;
  public link: string;
  public scrollToDiv: string;
  public classActive: string;
}
